export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q01_a.7649e0a7.png";